import { useRef, useCallback } from 'react';

export function useAnimatedHeight(duration = 300) {
    const contentRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const animate = useCallback(() => {
        if (!containerRef.current || !contentRef.current) {
            return;
        }

        const container = containerRef.current;
        const element = contentRef.current;

        container.style.transition = `height ${duration}ms ease-in-out`;
        container.style.height = `${element.scrollHeight}px`;
    }, [duration]);

    return { containerRef, contentRef, animate };
}
